import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import customerDatas from '../datas/customer'
import mallOrderDatas from '../datas/mall-order'
import { transform } from 'ajv-keywords/keywords'
let customerAction = {
  // 获取商城用户
  getMallUser(ctx, data) {
    return fetch.getMallUser(data).then(res => {
      let result = getTotalNumber(res)
      return customerAction.businessSource().then(businessSourceList => {
        result.data = customerDatas.getMallUser(result.data, businessSourceList)
        return result
      })
    })
  },
  mallUserDetail(ctx, id) {
    return fetch.mallUserDetail(id).then(res => {
      return customerAction.businessSource().then(businessSourceList => {
          let result = customerDatas.mallUserDetail(res.data, businessSourceList)
          return result
        })
        //   let result = customerDatas.mallUserDetail(res.data)
        //   return result
    })
  },
  getUserDetailAddress(ctx, id) {
    return fetch.getUserDetailAddress(id).then(res => {
      return customerAction.businessSource().then(businessSourceList => {
        let result = customerDatas.mallUserDetail(res.data, businessSourceList)
        return result
      })
    })
  },
  healthRecords(ctx, data) {
    return fetch.healthRecords(data).then(res => {
      let result = getTotalNumber(res)
      result.data = customerDatas.healthRecords(result.data)
      return result
    })
  },
  getUserIntegral(ctx, data) {
    return fetch.getUserIntegral(data).then(res => {
      return res.data
    })
  },
  getUserIntegralType(ctx, data) {
    return fetch.getUserIntegralType(data).then(res => {
      return res.data
    })
  },
  getUserIntegralList(ctx, data) {
    return fetch.getUserIntegralList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = customerDatas.getUserIntegralList(result.data)
      return result
    })
  },
  lifeMilestone(ctx, data) {
    return fetch.lifeMilestone(data).then(res => {
      //   let result = getTotalNumber(res)
      let result = getTotalNumber(res)
      result.data = customerDatas.lifeMilestone(result.data)
      return result
    })
  },
  getHealthRecordDetail(ctx, id) {
    return fetch.getHealthRecordDetail(id).then(res => {
      let result = customerDatas.getHealthRecordDetail(res.data)
      return result
    })
  },
  pageInvitationUsers(ctx, data) {
    return fetch.pageInvitationUsers(data).then(res => {
      let result = getTotalNumber(res)
      return customerAction.businessSource().then(businessSourceList => {
        result.data = customerDatas.getMallUser(result.data, businessSourceList)
        return result
      })
    })
  },
  getAllCity(ctx) {
    return fetch.getAllCity().then(res => {
      return res.data
    })
  },
  getAllMallUser(ctx) {
    return fetch.getAllMallUser().then(res => {
      return res.data
    })
  },
  businessSource() {
    return fetch.businessSource().then(res => {
      return res.data
    })
  },
  systemCustomerList(ctx, data) {
    return fetch.systemCustomerList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = customerDatas.systemCustomerList(result.data)
      return result
    })
  },
  getOrganizationsCustomer(ctx) {
    return fetch.getOrganizations().then(res => {
      let result = customerDatas.getOrganizations(res.data)
      return result
    })
  },
  rolesList(ctx, data) {
    return fetch.rolesList(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  createdOrgCustomer(ctx, data) {
    return fetch.createdOrgCustomer(data).then(res => {
      return res.data
    })
  },
  organizationUserInformation(ctx, data) {
    return fetch.organizationUserInformation(data).then(res => {
      return res.data
    })
  },
  deleteOrganizationUser(ctx, data) {
    return fetch.deleteOrganizationUser(data).then(res => {
      return res.data
    })
  },
  updateOrganizationUser(ctx, data) {
    return fetch.updateOrganizationUser(data).then(res => {
      return res.data
    })
  },
  rolesStatistics(ctx, data) {
    return fetch.rolesStatistics(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  getPermissionsList(ctx, data) {
    return fetch.getPermissionsList(data).then(res => {
      let result = res.data
      return result
    })
  },
  createdRoles(ctx, data) {
    return fetch.createdRoles(data).then(res => {
      return res.data
    })
  },
  rolesDetail(ctx, name) {
    return fetch.rolesDetail(name).then(res => {
      return res.data
    })
  },
  walletAccountDetail(ctx, id) {
    return fetch.walletAccountDetail(id).then(res => {
      let result = customerDatas.walletAccountDetail(res.data)
      return result
    })
  },
  walletAccountRecord(ctx, data) {
    return fetch.walletAccountRecord(data).then(res => {
      let result = getTotalNumber(res)
      result.data = customerDatas.walletAccountRecord(result.data)
      return result
    })
  },
  walletAccountEdit(ctx, data) {
    return fetch.walletAccountEdit(data).then(res => {
      return res.data
    })
  },
  rolesDelete(ctx, id) {
    return fetch.rolesDelete(id).then(res => {
      return res.data
    })
  },
  rolesEdit(ctx, data) {
    return fetch.rolesEdit(data).then(res => {
      return res.data
    })
  },
  familyListTable(ctx, data) {
    return fetch.familyListTable(data).then(res => {
      let result = getTotalNumber(res)
      result.data = customerDatas.familyListTable(result.data)
      return result
    })
  },
  inviteCustomerTotal(ctx, data) {
    return fetch.inviteCustomerTotal(data).then(res => {
      return res.data
    })
  },
  inviteCustomerBringNew(ctx, data) {
    return fetch.inviteCustomerBringNew(data).then(res => {
      let result = getTotalNumber(res)
      result.data = customerDatas.inviteCustomerBringNew(result.data)
      return result
    })
  },
  mallUserCoupons(ctx, data) {
    return fetch.mallUserCoupons(data).then(res => {
      let result = getTotalNumber(res)
      result.data = customerDatas.mallUserCoupons(result.data)
      return result
    })
  },
  couponUsed(ctx, id) {
    return fetch.couponUsed(id).then(res => {
      return res.data
    })
  },
  getUserSamples(ctx, data) {
    return fetch.getUserSamples(data).then(res => {
      let result = getTotalNumber(res)
      result.data = customerDatas.getUserSamples(res.data)
      return result
    })
  },
  getUserContracts(ctx, data) {
    return fetch.getUserContracts(data).then(res => {
      let result = getTotalNumber(res)
      result.data = customerDatas.getUserContracts(res.data)
      return result
    })
  },
  getCPSSyn(ctx, data) {
    return fetch.getCPSSyn(data).then(res => {
      return res
    })
  },
  toVisibleReport(ctx, data) {
    return fetch.toVisibleReport(data).then(res => {
      return res
    })
  },
  ReportDetail(ctx, data) {
    return fetch.ReportDetail(data).then(res => {
      return res
    })
  },
  getMallSampleById(ctx, id) {
    return fetch.getMallSampleById(id).then(res => {
      return res
    })
  },
  deleteMallSample(ctx, id) {
    return fetch.deleteMallSample(id).then(res => {
      return res
    })
  },
  exportCustomerList(ctx, data) {
    return fetch.exportCustomerList(data).then(res => {
      return res
    })
  },
  exportHistoryOfCustomer(ctx, data) {
    return fetch.exportHistoryOfCustomer(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallOrderDatas.exportHistoryList(result.data)
      return result
    })
  },
  exportHistoryOfIntegral(ctx, data) {
    return fetch.exportHistoryOfIntegral(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallOrderDatas.exportHistoryList(result.data)
      return result
    })
  },
  customerMemberLevelInfo(ctx, data) {
    return fetch.customerMemberLevelInfo(data).then(res => {
      let result = customerDatas.customerMemberLevelInfo(res.data)
      return result
    })
  },
  getBasicReport(ctx, id) {
    return fetch.getBasicReport(id).then(res => {
      let result = res.data
      result = result ? '已出' : '未出'
      return result
    })
  },
  getStorageProgress(ctx, id) {
    return fetch.getStorageProgress(id).then(res => {
      let result = customerDatas.getStorageProgress(res.data)
      return result
    })
  },
  getCPSStorageProgress(ctx, id) {
    return fetch.getCPSStorageProgress(id).then(res => {
      let result = customerDatas.getCPSStorageProgress(res.data)
      return result
    })
  },
  getAnnualReport(ctx, data) {
    return fetch.getAnnualReport(data).then(res => {
      let result = customerDatas.getAnnualReport(res.data, data)
      return result
    })
  },
  getUserWxInfo(ctx, data) {
    return fetch.getUserWxInfo(data).then(res => {
      let result = res.data || {}
      if (result.openIds) {
        result.openId = result.openIds.mp
      }
      return result
    })
  },
  unbindWx(ctx, data) {
    return fetch.unbindWx(data).then(res => {
      return res
    })
  },
  unbindCps(ctx, data) {
    return fetch.unbindCps(data).then(res => {
      return res
    })
  },
  registryCpsUser(ctx, userLogin) {
    return fetch.registryCpsUser(userLogin).then(res => {
      return res
    })
  },
  getCpsInfoByLogin(ctx, data) {
    return fetch.getCpsInfoByLogin(data).then(res => {
      return res.data
    })
  },
  getInvoiceList(ctx, userLogin) {
    return fetch.getInvoiceList(userLogin).then(res => {
      return res.data
    })
  },
  getInvoiceSyn(ctx, userLogin) {
    return fetch.getInvoiceSyn(userLogin).then(res => {
      return res.data
    })
  }
}
export default customerAction